import type { XeroInvoiceState } from '../../types'
import { formatDate } from './helpers'

interface CreateLicenseInvoiceStepProps {
  selectedXeroId: string
  setSelectedXeroId: (id: string) => void
  availableInvoices: XeroInvoiceState[]
  usedInvoices: XeroInvoiceState[]
  selectedXero: XeroInvoiceState | undefined
}

function SelectedInvoiceDetails({ invoice }: { invoice: XeroInvoiceState }): React.ReactElement {
  const paidOnDisplay = invoice.fullyPaidOn ? formatDate(invoice.fullyPaidOn) : 'N/A'
  const invoiceNumber = invoice.xeroInvoiceNumber === '' ? 'N/A' : invoice.xeroInvoiceNumber
  return (
    <div className="mt-2 rounded-lg bg-stone-50 p-3 text-sm dark:bg-stone-700/50">
      <div className="grid grid-cols-2 gap-2">
        <div>
          <span className="text-stone-500 dark:text-stone-400">Invoice:</span> {invoiceNumber}
        </div>
        <div>
          <span className="text-stone-500 dark:text-stone-400">Amount:</span> {invoice.currencyCode}{' '}
          {invoice.amountPaid.toFixed(2)}
        </div>
        <div>
          <span className="text-stone-500 dark:text-stone-400">Paid On:</span> {paidOnDisplay}
        </div>
        <div>
          <span className="text-stone-500 dark:text-stone-400">Status:</span>{' '}
          <span className="text-green-600 dark:text-green-400">{invoice.invoiceStatus}</span>
        </div>
      </div>
    </div>
  )
}

export function CreateLicenseInvoiceStep(props: CreateLicenseInvoiceStepProps): React.ReactElement {
  const { selectedXeroId, setSelectedXeroId, availableInvoices, usedInvoices, selectedXero } = props
  const usedSummary =
    usedInvoices.length > 0
      ? `${String(usedInvoices.length)} invoice(s) already used: ${usedInvoices
          .map((entry) => entry.xeroInvoiceNumber)
          .join(', ')}`
      : null
  return (
    <div>
      <label className="mb-2 block text-sm font-medium text-stone-700 dark:text-stone-300">
        2. Select Paid Invoice (Payment Gate)
      </label>
      <select
        value={selectedXeroId}
        onChange={(event) => {
          setSelectedXeroId(event.target.value)
        }}
        className="w-full rounded-lg border border-stone-300 bg-white px-3 py-2 text-stone-900 dark:border-stone-600 dark:bg-stone-700 dark:text-stone-100"
      >
        <option value="">Select invoice...</option>
        {availableInvoices.map((invoice) => (
          <option key={invoice.id} value={invoice.id}>
            {invoice.xeroInvoiceNumber} - {invoice.currencyCode} {invoice.amountPaid.toFixed(2)}{' '}
            (Paid)
          </option>
        ))}
      </select>
      {usedSummary !== null && (
        <p className="mt-1 text-xs text-stone-500 dark:text-stone-400">{usedSummary}</p>
      )}
      {selectedXero && <SelectedInvoiceDetails invoice={selectedXero} />}
    </div>
  )
}
